<div class="org-tree-filter">
  <div class="w-full">
    <div class="mat-subheading-2">Filter by Line of Business</div>

    <app-org-filter
      [organisations]="organisations"
      (filterOrganisations)="filterOrganisations($event)"
    ></app-org-filter>
  </div>

  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <!-- Leaf node -->
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
      <span class="tree-node-spacer" aria-hidden="true"></span>

      <mat-checkbox
        class="checklist-leaf-node"
        [checked]="isNodeVisuallySelected(node)"
        (click)="$event.stopPropagation()"
        (change)="leafOrgSelectionToggle(node)"
      >
        {{ node.name }}
      </mat-checkbox>
    </mat-tree-node>

    <!-- Expandable node -->
    <mat-tree-node
      *matTreeNodeDef="let node; when: hasChild"
      matTreeNodePadding
    >
      <button
        mat-icon-button
        matTreeNodeToggle
        type="button"
        (click)="$event.stopPropagation()"
        [attr.aria-label]="
          treeControl.isExpanded(node)
            ? 'Collapse ' + node.name
            : 'Expand ' + node.name
        "
        [attr.title]="
          treeControl.isExpanded(node)
            ? 'Collapse ' + node.name
            : 'Expand ' + node.name
        "
      >
        <mat-icon>
          {{ treeControl.isExpanded(node) ? "expand_more" : "chevron_right" }}
        </mat-icon>
      </button>

      <mat-checkbox
        class="checklist-leaf-node"
        [checked]="isNodeVisuallySelected(node)"
        [indeterminate]="descendantsPartiallySelected(node)"
        (click)="$event.stopPropagation()"
        (change)="orgSelectionToggle(node)"
      >
        {{ node.name }}
      </mat-checkbox>
    </mat-tree-node>
  </mat-tree>
</div>
